<template>
  <v-layout>
    <div class="page-banner banner-digital">
      <div class="page-banner-mask" />
      <div class="banner-inner">
        <h1><span class="icon-browser" />Digital Media</h1>
        <p>How your customers see you on the web, phone, and tablet.</p>
      </div>
    </div>
    <el-container class="lower-shadow intro-section">
      <el-main class="site-inner">
        <el-row :gutter="20">
          <el-col
            :xs="24"
            class="article-bottom-margin">
            <h2>Not Just Websites</h2>
            <p>While you wouldn't be wrong if the first thing you thought of was websites, Digital Media covers more
            areas than that.
            Email Campaigns have their own requirements and traps that many businesses fall victim to all the time.
            Not to mention that many businesses overlook the value of making sure their digital presence accounts for
            their ADA customer base.</p>
            <p>Here we will go into details on some of the larger items in this category,
            to help demonstrate all of the extra items that fall under these items and help better illustrate
            Ingalls Image's ability to be your only need for any Digital Media services</p>
          </el-col>
        </el-row>
      </el-main>
    </el-container>
    <el-container class="sunken-container web-site-design lower-shadow">
      <el-main class="sunken-wrapper">
        <el-card class="sunken-inner">
          <div
            slot="header"
            class="sunken-header">
            <h2>
              <span class="icon-document-file-html"/>Websites
            </h2>
          </div>
          <div class="sunken-body">
            <p>We are keenly aware the we said "Not Just Websites" above, but websites are what everyone thinks when
            you say digital media for a reason.
            Websites are a large part of any business as they serve many uses. A well crafted website is as much
            information tool, as it is marketing,
            and many overlook the power that first impression can have. Something as small as how you handle your
            missing link page, also known as a 404 page,
            can lead some potential customers to wonder if your business is active or if this is a long dead site
            that is just still on the web.
            </p>
            <service-section>
              <h3 slot="header">Our Web Site Services:</h3>
              <span class="one-col-xs two-col-sm three-col-md">
                <service-article
                  :in-row="false"
                  class="collapse-wrapper uncollapse-sm">
                  <h4
                    slot="header"
                    @click="collapseToggle($event)">
                    <span class="header-icon icon-tools" />Web Design
                    <span class="collapse-icon icon-chevron-with-circle-up" />
                  </h4>
                  <span>
                    <p>Have an existing site that needs a new look or in the market for a whole new design to launch a
                    new endeavor? Ingalls Image can help either way. Our designs use concepts that are current, and
                    we work to make sure we stay that way.</p>
                  </span>
                </service-article>
                <service-article
                  :in-row="false"
                  class="collapse-wrapper uncollapse-sm">
                  <h4
                    slot="header"
                    @click="collapseToggle($event)">
                    <span class="header-icon icon-gears" />
                    <span class="hidden-xs-only">Web Development</span>
                    <span class="hidden-sm-and-up">Web Dev</span>
                    <span class="collapse-icon icon-chevron-with-circle-up" />
                  </h4>
                  <span>
                    <p>Have a design but need it to be brought to life? Or did we create a design and now you need it
                    made? We got your back there too. Let us create your website using coding standards that will
                    guarantee your site works across all standard browsers.</p>
                  </span>
                </service-article>
                <service-article
                  :in-row="false"
                  class="collapse-wrapper uncollapse-sm">
                  <h4
                    slot="header"
                    @click="collapseToggle($event)">
                    <span class="header-icon icon-toolbox" />Web Hosting
                    <span class="collapse-icon icon-chevron-with-circle-up" />
                  </h4>
                  <span>
                    <p>Ever forget to pay for a domain name or server space? Or did you not even know those are things
                    to worry about? Then let Ingalls Image handle that for you as well. We make sure your domain and
                    web site stay live and keep the lights on.</p>
                  </span>
                </service-article>
                <service-article
                  :in-row="false"
                  class="collapse-wrapper uncollapse-sm">
                  <h4
                    slot="header"
                    @click="collapseToggle($event)">
                    <span class="header-icon icon-mobile" />Responsive
                    <span class="collapse-icon icon-chevron-with-circle-up" />
                  </h4>
                  <span>
                    <p>Was your site built before phones could load images? Or did you just not think responsive design
                    was going to be a thing that took off? You’re not alone, and we can help. While our sites are
                    built responsive right from the beginning, we can take your existing site and give it a
                    responsiveness band-aid while we help you explore other options for long term.</p>
                  </span>
                </service-article>
                <service-article
                  :in-row="false"
                  class="collapse-wrapper uncollapse-sm">
                  <h4
                    slot="header"
                    @click="collapseToggle($event)">
                    <span class="header-icon icon-basket" />eCommerce
                    <span class="collapse-icon icon-chevron-with-circle-up" />
                  </h4>
                  <span>
                    <p>Looking to sell some items on the vastness that is the web? Let us help set up your digital
                    store front. We can even help set you up with an order fulfillment service that works straight
                    through your own website in most cases.</p>
                  </span>
                </service-article>
                <service-article
                  :in-row="false"
                  class="collapse-wrapper uncollapse-sm">
                  <h4
                    slot="header"
                    @click="collapseToggle($event)">
                    <span class="header-icon icon-magnifying-glass" />SEO
                    <span class="collapse-icon icon-chevron-with-circle-up" />
                  </h4>
                  <span>
                    <p>Another service we offer with out standard website development, but we are happy to help your
                    with your existing site, working to help you reach more eyes and get more customers by making
                    your site more visible to your everyday customer base.</p>
                  </span>
                </service-article>
                <service-article
                  :in-row="false"
                  class="collapse-wrapper uncollapse-sm">
                  <h4
                    slot="header"
                    @click="collapseToggle($event)">
                    <span class="header-icon icon-eye-hidden" />ADA Compliance
                    <span class="collapse-icon icon-chevron-with-circle-up" />
                  </h4>
                  <span>
                    <p>Have a customer base that may have visual, hearing, or other physical handicaps? We understand
                    the struggles involved and the extra lengths that are needed to help those customers have a
                    positive experience on your website. We can help you, to help all your customers get what they
                    need and where they need to go to on your existing or new website.</p>
                  </span>
                </service-article>
                <service-article
                  :in-row="false"
                  class="collapse-wrapper uncollapse-sm">
                  <h4
                    slot="header"
                    @click="collapseToggle($event)">
                    <span class="header-icon icon-documents" />
                    <span class="hidden-xs-only">Content Management</span>
                    <span class="hidden-sm-and-up">CMS</span>
                    <span class="collapse-icon icon-chevron-with-circle-up" />
                  </h4>
                  <span>
                    <p>Good sites are active sites. This means some way, shape, or form the site grows and changes.
                    Adding new content and expanding on existing content are great ways to manage this. We can help
                    in multiple ways. We can manage your content and work with you to make it grow regularly, or we
                    can teach you how to and you can take a personal involvement into your site with a guiding hand.</p>
                  </span>
                </service-article>
                <service-article
                  :in-row="false"
                  class="collapse-wrapper uncollapse-sm">
                  <h4
                    slot="header"
                    @click="collapseToggle($event)">
                    <span class="header-icon icon-shield" />Disaster Recovery
                    <span class="collapse-icon icon-chevron-with-circle-up" />
                  </h4>
                  <span>
                    <p>Where would you be if your current site just winked out of existence right now? How quickly can
                    you be back up and how much data is lost in the process? Not sure, or not happy with the amount
                    lost? Let us help you plan for the future no one wants or hopes happens but can’t be ignored.</p>
                  </span>
                </service-article>
              </span>
            </service-section>
          </div>
        </el-card>
      </el-main>
    </el-container>
    <div class="shadow-bar lower-shadow" />

    <el-container class="sunken-container email-campaign lower-shadow">
      <el-main class="sunken-wrapper">
        <el-card class="sunken-inner">
          <div
            slot="header"
            class="sunken-header">
            <h2>
              <span class="icon-envelope"/>Email Campaigns
            </h2>
          </div>
          <div class="sunken-body">
            <p>Email campaigns are one of the many ways to keep re-engaging your customers, share information about
            upcoming events, and send promotional offers to entice return business. Ingalls Image can help you make
            sure the message is clear, and the presentation is clean. We work hard to make sure no matter what device
            your campaigns are viewed on, they look great and send a clear message. </p>
            <service-section>
              <h3 slot="header">Our Email Campaign Services:</h3>
              <span class="one-col-xs two-col-sm three-col-md">

                <service-article
                  :in-row="false"
                  class="collapse-wrapper uncollapse-sm">
                  <h4
                    slot="header"
                    @click="collapseToggle($event)">
                    <span class="header-icon icon-code"/>HTML Emails
                    <span class="collapse-icon icon-chevron-with-circle-up" />
                  </h4>
                  <span>
                    <p>We can prepare HTML emails designed and themed to your business, tested to work and show the
                    same message on all major email applications and mobile devices. HTML Email templates all come
                    with a Text version backup for any customers on older machines or who are not able to receive
                    HTML emails for any reasons.</p>
                  </span>
                </service-article>

                <service-article
                  :in-row="false"
                  class="collapse-wrapper uncollapse-sm">
                  <h4
                    slot="header"
                    @click="collapseToggle($event)">
                    <span class="header-icon icon-piechart" />Analytics
                    <span class="collapse-icon icon-chevron-with-circle-up" />
                  </h4>
                  <span>
                    <p>Track the number of emails that were opened and links clicked. Get an idea of how successful any
                    given campaign was and build a profile to see your lead conversions.</p>
                  </span>
                </service-article>

                <service-article
                  :in-row="false"
                  class="collapse-wrapper uncollapse-sm">
                  <h4
                    slot="header"
                    @click="collapseToggle($event)">
                    <span class="header-icon icon-user-o" />Dynamic Content
                    <span class="collapse-icon icon-chevron-with-circle-up" />
                  </h4>
                  <span>
                    <p>Personalize your emails with your customers names and information so the message can better
                    resonate with them. Make sure they don’t think you see them as another number on a spreadsheet
                    somewhere.</p>
                  </span>
                </service-article>

                <service-article
                  :in-row="false"
                  class="collapse-wrapper uncollapse-sm">
                  <h4
                    slot="header"
                    @click="collapseToggle($event)">
                    <span class="header-icon icon-compare" />A/B Testing
                    <span class="collapse-icon icon-chevron-with-circle-up" />
                  </h4>
                  <span>
                    <p>We can put together different campaign look and feel to test what resonates better with your
                    customer base to help future campaigns be more successful.</p>
                  </span>
                </service-article>

                <service-article
                  :in-row="false"
                  class="collapse-wrapper uncollapse-sm">
                  <h4
                    slot="header"
                    @click="collapseToggle($event)">
                    <span class="header-icon icon-filter" />Landing Page
                    <span class="collapse-icon icon-chevron-with-circle-up" />
                  </h4>
                  <span>
                    <p>Personalized web page to serve as a landing page for your email marketing campaigns for
                    analytics purposes and to keep your customers interested to turn those cold leads into hot leads.</p>
                  </span>
                </service-article>

              </span>
            </service-section>
          </div>
        </el-card>
      </el-main>
    </el-container>
  </v-layout>
</template>

<script>
import ServiceSection from '@/layouts/sections/services.vue';
import ServiceArticle from '@/layouts/articles/service.vue';
import 'element-ui/lib/theme-chalk/display.css';

/* ============
 * Home Index Page
 * ============
 *
 * The home index page.
 */

import VLayout from '@/layouts/Default.vue';

export default {
  /**
   * The name of the page.
   */
  name: 'DigitalMedia',

  metaInfo: {
    title: 'Ingalls Image', // set a title
    titleTemplate: 'Digital Media | %s', // title is now "My Example App - Yay!"
    htmlAttrs: {
      lang: 'en',
      amp: undefined, // "amp" has no value
    },
    meta: [
      { itemprop: 'name', content: 'Digital Media | Ingalls Image' },
      { itemprop: 'description', content: 'Your digital dream needs are but one call away from being a reality.  Let us help you create or update your digital works and help your customers find you easier on their favoritre devices.' },
      { itemprop: 'image', content: 'https://www.ingallsimage.com/img/open-graph/digital-media.jpg' },
      { property: 'og:title', content: 'Digital Media | Ingalls Image' },
      { property: 'og:description', content: 'Your digital dream needs are but one call away from being a reality.  Let us help you create or update your digital works and help your customers find you easier on their favoritre devices.' },
      { name: 'description', property: 'description', content: 'Your digital dream needs are but one call away from being a reality.  Let us help you create or update your digital works and help your customers find you easier on their favoritre devices.' },
      { property: 'og:image', content: 'https://www.ingallsimage.com/img/open-graph/digital-media.jpg' },
      { property: 'og:url', content: 'https://www.ingallsimage.com/digital-media' },
    ],
    link: [
      { rel: 'canonical', href: 'https://www.ingallsimage.com/digital-media' },
    ],
  },
  /**
   * The components that the page can use.
   */
  components: {
    VLayout,
    ServiceSection,
    ServiceArticle,
  },
  data() {
    return {
    };
  },
  mounted() {
    this.$ga.page(this.$router);
  },
  methods: {
    collapseToggle(e) {
      let parent = e.target.parentElement;
      if (parent.nodeName === 'H4') {
        parent = e.target.parentElement.parentElement;
      }
      const grandParent = parent.parentElement;
      const main = parent.nextSibling;
      if (main.style.maxHeight) {
        main.style.maxHeight = null;
        grandParent.classList.remove('collapse-active');
      } else {
        main.style.maxHeight = `${main.scrollHeight}px`;
        grandParent.classList.add('collapse-active');
      }
    },
  },
};
</script>
